var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_57122",
    "data-name": "Group 57122",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.45,
    height: 24.593,
    viewBox: "0 0 33.45 24.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25898",
    "data-name": "Path 25898",
    d: "M55.119,59.178a.235.235,0,0,0,.043.234.315.315,0,0,0,.242.108h3.574a.293.293,0,0,0,.293-.207l2.467-10.075a1.223,1.223,0,0,0-1-1.5,1.437,1.437,0,0,0-1.719.865Zm-19.656.135a.293.293,0,0,0,.293.207h3.574a.314.314,0,0,0,.242-.108.235.235,0,0,0,.043-.234L35.708,48.6a1.437,1.437,0,0,0-1.718-.861,1.223,1.223,0,0,0-.994,1.5Z",
    transform: "translate(-30.641 -46.574)",
    fill: "#e69807",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25900",
    "data-name": "Path 25900",
    d: "M61.28,196.78a.234.234,0,0,0,.021-.271.306.306,0,0,0-.265-.141H32.648a.307.307,0,0,0-.265.141.235.235,0,0,0,.021.271l.853,1.06a1.87,1.87,0,0,0,1.458.662H58.969a1.871,1.871,0,0,0,1.458-.662Z",
    transform: "translate(-30.117 -173.909)",
    fill: "none",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25901",
    "data-name": "Path 25901",
    d: "M48.033,138.989a1.468,1.468,0,0,0-1.544-1.378H16.127a1.468,1.468,0,0,0-1.544,1.378v5.151a1.468,1.468,0,0,0,1.544,1.378H46.488a1.468,1.468,0,0,0,1.544-1.378Z",
    transform: "translate(-14.583 -122.536)",
    fill: "#e69807",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25902",
    "data-name": "Path 25902",
    d: "M41.163,156.811a1.072,1.072,0,0,0-1.139.987v1.107a1.151,1.151,0,0,0,2.278,0V157.8A1.072,1.072,0,0,0,41.163,156.811Zm3.558,0a1.072,1.072,0,0,0-1.139.987v1.107a1.151,1.151,0,0,0,2.278,0V157.8A1.072,1.072,0,0,0,44.721,156.811Zm3.558,0c-.629,0-.854.464-1.139.987a1.322,1.322,0,0,0,0,1.107,1.151,1.151,0,0,0,2.278,0V157.8A1.072,1.072,0,0,0,48.279,156.811Zm17.023,0a1.556,1.556,0,1,0,1.778,1.541A1.673,1.673,0,0,0,65.3,156.811Z",
    transform: "translate(-36.827 -139.889)",
    fill: "#fff",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1459",
    "data-name": "Ellipse 1459",
    cx: 1.819,
    cy: 1.819,
    r: 1.819,
    transform: "translate(14.906 7.565)",
    fill: "#e69807"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25903",
    "data-name": "Path 25903",
    d: "M106.77,67.731a4.822,4.822,0,0,0-8.654,0,1.088,1.088,0,1,0,1.952.961,2.646,2.646,0,0,1,4.751,0,1.088,1.088,0,1,0,1.952-.961Z",
    transform: "translate(-85.718 -61.733)",
    fill: "#e69807",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25904",
    "data-name": "Path 25904",
    d: "M95.324,42.166a7.3,7.3,0,0,0-12.368,0A1.088,1.088,0,0,0,84.8,43.324a5.123,5.123,0,0,1,8.684,0,1.088,1.088,0,1,0,1.842-1.158Z",
    transform: "translate(-72.415 -38.744)",
    fill: "#e69807",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.42e9f2ce56560a8f5ecb921533f2dc18.svg";
export { ForwardRef as ReactComponent };